import { ENDPOINTS } from "@/constants/endpoint";
import { api } from "@/lib/api";

export async function getBlogs({
  limit = 10,
  page = 1,
  endpoint = ENDPOINTS.BLOGS,
  city,
  fetchConfig,
} = {}) {
  try {
    const { data: json, ok } = await api.get(
      endpoint,
      {
        limit: String(limit),
        page: String(page),
        ...(city ? { city } : {}),
      },
      fetchConfig,
    );

    if (!ok || !json?.status) return { data: [], total: 0 };

    const data = Array.isArray(json?.data?.data)
      ? json.data.data
      : Array.isArray(json?.data)
        ? json.data
        : [];

    const total = json?.data?.total ?? json?.total ?? data.length;
    return { data, total };
  } catch {
    return { data: [], total: 0 };
  }
}
